import React, { Component } from 'react';
import { Row, Radio, Tag, Descriptions, Divider, Tooltip, Badge, Button, Popconfirm } from 'antd';
import Text from 'antd/lib/typography/Text';
import { formatMoney } from '../lib/util';
import { Link } from 'react-router-dom';

const scored_data=[
    {key:'txn_date',value:"2018-12-12",score:3}
]

class BatchItemSelector extends Component {
    render() {
        let data = this.props.data || {};
        let selectedID = this.props.selectedID;
        let itemID = this.props.itemID;
        let isSelectable=this.props.isSelectable;
        let batch_mode=this.props.batch_mode||'Manual';
        let  selected_left=this.props.selected_left;
        let side=this.props.side;



        return (
            <div>
            <Row type='flex' justify='start' style={{
                alignItems: 'center',
                flexWrap: 'nowrap',
            }}>
                {/* <Radio  checked={itemID && selectedID && (itemID === selectedID)} onChange={(e) => {
                    e.stopPropagation()
                    isSelectable && typeof this.props.onSelected === 'function' && this.props.onSelected(itemID,data);

                    // For unclassified transaction
                    this.props.isRuleSelector&&Array.isArray(data.rules)&&this.props.onRuleSelected(data.id,data,data.rules[0]||{})
                }} /> */}

                <Row type='flex' className='default-card hand-cursor' style={{ padding: 8, flex: 1, width: 10, margin: 0,
                // opacity:((selectedID&&itemID&&selectedID!=itemID)?0.5:1) ,
                backgroundColor: (itemID && selectedID && (itemID === selectedID)) ? '#e8e8e8' : null 
            }} onClick={(e) => {
                    e.stopPropagation()

                    isSelectable && typeof this.props.onSelected === 'function' && this.props.onSelected(itemID,data);
                    
                    // For unclassified transaction
                    this.props.isRuleSelector&&Array.isArray(data.rules)&&this.props.onRuleSelected(data.id,data,data.rules[0]||{})

                }}>
                    <Row type='flex' justify='space-between' style={{ width: '100%', alignItems: 'center' }}>
                        <div style={{
                            flex:1
                        }}>
                    <div style={{backgroundColor:data.type=='C'?'#4062BB':'#4E937A'}} className='dr-cr-text'>
                        {data.type}
                    </div> 
                        </div>
                    
                        <span style={{ color: 'black', fontSize: 18, flex: 1 }}>{data.txn_date}</span>
                        <span style={{ color: 'black', fontSize: 18, opacity: 0.5, flex: 1, textAlign: 'center' }}>{data.transaction_id}</span>
                        {/* {data.score!=null&&
                        <Tag color="#108ee9">{data.score}</Tag>
                        } */}
                        <span style={{
                            alignItems: 'center',
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'flex-end',
                        }}>
                            <span style={{
                                fontWeight: 'bold',
                                fontSize: 20,
                                color: 'steelblue',

                            }}>Rs. {formatMoney(data.amount)}</span>
                            {/* <Text style={{
                                borderLeft: '1px solid rgba(0,0,0,0.2)',
                                paddingLeft: 4,
                                marginLeft: 4,
                                color: 'green'
                            }}>{data.type}</Text> */}
                            {/* <Tag color='green' style={{ height: 'fit-content',marginLeft:6 }}>C</Tag> */}
                        </span>
                    </Row>
                    <span style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: 'rgba(0,0,0,0.2)',
                        marginTop: 4
                    }}></span>


                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            overflow: 'auto'
                        }}>
                            <span onClick={(e) => {
                                // console.log(e);
                                if (e.currentTarget.style.overflow === 'hidden') {
                                    e.currentTarget.style.overflow = 'visible';
                                    e.currentTarget.style.whiteSpace = 'unset'
                                } else {
                                    e.currentTarget.style.overflow = 'hidden';
                                    e.currentTarget.style.whiteSpace = 'nowrap'
                                }
                            }} style={{
                                display: 'block',
                                paddingTop: 4,
                                opacity: 0.5,
                                wordBreak: 'break-all',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontSize: 16
                            }}>
                                {data.description}
                            </span>
                            {itemID &&<Row type='flex' justify='space-between' align='middle'>
                                <Link to={{
                                    pathname: `/processors/${itemID}`,
                                    // state:{
                                    //     showTransactionModal:true
                                    // }
                                }}
                                onClick={(e)=>{
                                    if(typeof this.props.onViewDetailClicked==='function'){
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.onViewDetailClicked(itemID)
                                    }
                                }}
                                >View Detail</Link>
                                 {batch_mode==='manual'&&side=='right'&&!selected_left&&<Button type='link' onClick={(e)=>{
                                     e.stopPropagation();
                                     e.preventDefault();
                                     typeof this.props.onCreateBatch==='function'&&this.props.onCreateBatch(itemID,data);
                                 }}>
                                Create Batch</Button>}
                                {selected_left&&side=='right'&&<Tooltip title="Add to batch and subtract amount">
                                <Popconfirm disabled title="Are you sure you want to add this transaction to selected batch?"
                                onConfirm={()=>{
                                    typeof this.props.onAddToBatch==='function'&&this.props.onAddToBatch(itemID,{add:false})
                                }}
                                ><Button type='link' onClick={()=>{
                                    typeof this.props.onAddToBatch==='function'&&this.props.onAddToBatch(itemID,{add:false})
                                }}>
                                 Subtract To Batch</Button></Popconfirm></Tooltip>}
                                {selected_left&&side=='right'&&
                                <Tooltip title="Add to batch and add amount">
                                <Popconfirm disabled title="Are you sure you want to add this transaction to selected batch?"
                                onConfirm={()=>{
                                    typeof this.props.onAddToBatch==='function'&&this.props.onAddToBatch(itemID,{add:true})
                                }}
                                >
                                <Button type='link' onClick={()=>{
                                    typeof this.props.onAddToBatch==='function'&&this.props.onAddToBatch(itemID,{add:true})
                                }}>
                                Add To Batch</Button></Popconfirm></Tooltip>}
                                </Row>
                            }
                        </div>

                        {data.score != null && <div style={{
                            marginLeft:4,
                            paddingLeft:4,
                            borderLeft:'1px solid rgba(0,0,0,0.2)',
                            display:'flex',
                            flexDirection:'column',
                            justifyContent:'center',
                        }}>
                            <Tag  style={{
                                marginRight:0
                            }} color={data.score==1?'#87d068':'blue'}>{(data.score*100).toLocaleString()}%</Tag>
                        </div>
                        }
                    </div>
                    {this.props.isRuleSelector&&<Row>
                    {Array.isArray(data.rules)&&data.rules.map((rule)=>{
                        return <Tooltip title={rule.rule_name} ><Tag
                        color={(itemID && selectedID && (itemID === selectedID)&&(rule.rule_id==this.props.selectedRule))?'#108ee9':null}
                        onClick={(e)=>{
                            e.preventDefault();
                            e.stopPropagation()
                            typeof this.props.onRuleSelected==='function'&&this.props.onRuleSelected(data.id,data,rule)
                        }}
                        className='hand-cursor'
                    >{rule.rule_name}</Tag></Tooltip>
                    })
                    }
                    </Row>}
                    <Row>

                    

                    {this.props.item_type==='recommended'&&Array.isArray(data.individual_scores)&&data.individual_scores.map((item)=>{
                        return <Tag  className='scored-tag' style={{
                            // color:'white',
                            fontWeight:'bolder',
                            padding:0,
                            marginBottom:4,
                        }}><div style={{display:'flex',flexDirection:'column'}}>
                            <div style={{display:'flex',flexDirection:'row',paddingLeft:4,paddingRight:4}}>
                                <div style={{flex:1}}>
                                {item.key} : {item.value}
                                </div>
                                <Divider style={{height:'auto'}} type='vertical'/>
                                <div style={{
                                    color:item.score<0.4?'#f5222d':item.score>0.8?'#52c41a':'#faad14'
                                }}>
                                    {(item.score*100).toLocaleString()}%
                                </div>
                            </div>
                            <div style={{
                                height:2,
                                width:'100%',
                                
                                background:`linear-gradient(90deg, MediumSeaGreen ${item.score*100}%, #ddd ${item.score*100}%)`,

                            }}>

                            </div>

                        </div>
                        </Tag>
                    })}
                    </Row>
                </Row>

            </Row>
            {this.props.extra_content}
            </div>
        );
    }
}

export default BatchItemSelector;
